import { TableHeadCell } from '@ovComponents/2-component/table/table';
import { useTranslation } from 'react-i18next';
import { getPortfolioCustomTargetHeadColumnSx } from './utils';

export const CustomAllocationHeadCell = ({ index }: { index: number }) => {
  const { t } = useTranslation(['components']);
  return (
    <TableHeadCell
      sx={getPortfolioCustomTargetHeadColumnSx()}
      data-testid={`portfolio-custom-target-head-${index}`}
    >
      {t('components:householdPortfolio.customTarget')}
    </TableHeadCell>
  );
};
